import React from 'react';

import { DesktopMapTypeSwitcher } from './DesktopMapTypeSwitcher/DesktopMapTypeSwitcher';
import { MobileMapTypeSwitcher } from './MobileMapTypeSwitcher/MobileMapTypeSwitcher';

import { useMediaQuery } from 'common/hooks';
import { useShowStreetView } from 'entities/map';

export const MapTypeSwitcher = ({
  show = true
}: MapTypeSwitcherProps) => {
  const { isMobile } = useMediaQuery();
  const showStreetView = useShowStreetView();

  if (showStreetView || !show) {
    return null;
  }

  if (isMobile) {
    return <MobileMapTypeSwitcher />
  }

  return (
    <DesktopMapTypeSwitcher />
  );
};

interface MapTypeSwitcherProps {
  show?: boolean;
}